import moment from "moment";
import { createDynamicThunk } from ".";

export const getProjectCodeListThunk = createDynamicThunk({
  typePrefix: "projectCodes/getProjectCodeListThunk",
  useHandleSearch: true,
});

export const addProjectCodeThunk = createDynamicThunk({
  typePrefix: "projectCodes/addProjectCodeThunk",
  endpoint: "/project-code",
  method: "POST",
  refreshList: true,
  listThunk: getProjectCodeListThunk,
});

export const editProjectCodeThunk = createDynamicThunk({
  typePrefix: "projectCodes/editProjectCodeThunk",
  endpoint: "/project-code",
  method: "PUT",
  refreshList: true,
  listThunk: getProjectCodeListThunk,
  transformResponse: (response) => response,
});

export const deleteProjectCodeThunk = createDynamicThunk({
  typePrefix: "/deleteProjectCodeThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getProjectCodeListThunk,
});

export const searchProjectCodesThunk = createDynamicThunk({
  typePrefix: "projectCodes/searchProjectCodes",
  endpoint: "/search", // backend search endpoint
  method: "POST",
  refreshList: false, // will refresh projectCodes.list in slice
  listThunk: getProjectCodeListThunk,
  transformResponse: (response) => {
    if (!response?.response) {
      return { list: [], totalCount: 0 };
    }
    return {
      list: response.response.map((records) => ({
        key: records?._id,
        departmentID: `${records.departmentID?.name} - ${records.departmentID?.code}`,
        code: records.code,
        clientName: records.clientName,
        companyName: records.companyName,
        approvers: records.approvers,
        status: records.status,
        createdAt: records.createdAt
          ? moment.utc(records.createdAt).local().format("DD-MM-YY hh:mm A")
          : "",
        updatedAt: records.updatedAt
          ? moment.utc(records.updatedAt).local().format("DD-MM-YY hh:mm A")
          : "",
      })),
      totalCount: response.totalCount || 0,
    };
  },
});

export const getApproverListThunk = createDynamicThunk({
  typePrefix: "users/getApproverListThunk",
  endpoint: "/users/findAll",
  method: "POST",
  transformResponse: (response) =>
    response?.response
      ?.filter(
        (approver) => approver?.roleID?.name === process.env.REACT_APP_AROLE
      )
      ?.map((approver) => ({
        label: approver?.name,
        value: approver?._id,
      })) || [],
});


